import { StatusPill, type StatusTone } from '@bb/ui';
import type { CanvasSummary } from '../../api/client.ts';

const LABELS: Record<CanvasSummary['status'] | 'idle', [string, StatusTone]> = {
  draft: ['Draft', 'neutral'],
  active: ['Active', 'success'],
  idle: ['Idle', 'warning'],
  paused_entries: ['Entries paused', 'warning'],
  paused_all: ['Paused', 'warning'],
  stopped: ['Stopped', 'danger'],
  archived: ['Archived', 'neutral'],
};

/** Status of a Canvas; an active Canvas without recent sends shows as Idle (BB-109). */
export function CanvasStatusBadge({ canvas }: { canvas: Pick<CanvasSummary, 'status' | 'idle'> }) {
  const [label, tone] = LABELS[canvas.idle ? 'idle' : canvas.status];
  return <StatusPill tone={tone}>{label}</StatusPill>;
}
